import { createSlice } from "@reduxjs/toolkit";
import { AddBrand, UpdateBrand, GetBrandList } from "services/other/brand.service";
import { toast } from 'react-toastify';

export const brandAddSlice = createSlice({
  name: "brandAdd",
  initialState: {
    brandAdd: {},
    brandAddLoading: false,
    brandAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddBrand.pending, (state) => {
      // toast.loading('We are adding the brand 🤯')
      state.brandAddLoading = true
    });

    builder.addCase(AddBrand.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New brand added successfully 👌');

      state.brandAdd = action.payload
      state.brandAddLoading = false
      state.brandAddError = null
    });

    builder.addCase(AddBrand.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the brand 😣")

      state.brandAddLoading = false
      state.brandAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const brandUpdateSlice = createSlice({
  name: "brandUpdate",
  initialState: {
    brandUpdate: {},
    brandUpdateLoading: false,
    brandUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateBrand.pending, (state) => {
      // toast.loading('We are updating the brand 🤯')
      state.brandUpdateLoading = true
    });

    builder.addCase(UpdateBrand.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.brandUpdate = action.payload
      state.brandUpdateLoading = false
      state.brandUpdateError = null
    });

    builder.addCase(UpdateBrand.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the brand 😣")

      state.brandUpdateLoading = false
      state.brandUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const brandListSlice = createSlice({
  name: "brandList",
  initialState: {
    brandList: [],
    brandListLoading: false,
    brandListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetBrandList.pending, (state) => {
      state.brandListLoading = true
    });

    builder.addCase(GetBrandList.fulfilled, (state, action) => {
      toast.dismiss();

      state.brandList = action.payload
      state.brandListLoading = false
      state.brandListError = null
    });

    builder.addCase(GetBrandList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the brand 😣")

      state.brandListLoading = false
      state.brandListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});